module.exports = __webpack_public_path__ + "media/images/sprites/blue-22f843f3659e3f83482ddd04eacc3b0b.png";